//codex-- Use website favicons with a page-icon fallback; reset failed state when a link changes.
import { useState } from 'react';
import { DocumentTextIcon } from '@heroicons/react/24/outline';
import { bookmarkIconUrl } from '../utils/bookmarks';

function SiteIcon({ source }) {
  const [failed, setFailed] = useState(false);
  if (!source || failed) return <DocumentTextIcon className="h-5 w-5 shrink-0 text-gray-400" aria-hidden="true" />;
  return <img src={source} alt="" aria-hidden="true" referrerPolicy="no-referrer" loading="lazy"
    onError={() => setFailed(true)} className="h-5 w-5 shrink-0 rounded-sm object-contain" />;
}

export default function BookmarkSiteIcon({ link }) {
  const source = bookmarkIconUrl(link);
  return <SiteIcon key={source} source={source} />;
}
